export default ($axios) => ({
  fetch(query) {
    return $axios.get('/rcs/keywords', { params: query }).then((response) => response.data);
  },
  store(payload) {
    return $axios.post('/rcs/keywords', payload).then((response) => response.data);
  },
});
